import { Game } from './game';

const canvas = document.getElementById('game') as HTMLCanvasElement;
const ui = document.getElementById('ui') as HTMLElement;

/** Playtest aid: surface uncaught errors on screen (the console isn't always reachable in embedded builds). */
function showError(msg: string): void {
  let el = document.getElementById('errbar');
  if (!el) {
    el = document.createElement('div');
    el.id = 'errbar';
    el.style.cssText = 'position:fixed;left:0;right:0;bottom:0;z-index:99;background:#5a0f1a;color:#fff;font:12px monospace;padding:6px 10px;white-space:pre-wrap;max-height:40vh;overflow:auto';
    document.body.appendChild(el);
  }
  el.textContent += msg + '\n';
}
window.addEventListener('error', (e) => showError(`${e.message} @ ${e.filename?.split('/').pop()}:${e.lineno}`));
window.addEventListener('unhandledrejection', (e) => showError('unhandled: ' + String((e as PromiseRejectionEvent).reason?.stack ?? (e as PromiseRejectionEvent).reason)));

const game = new Game(canvas, ui);
game.start().catch((e) => {
  console.error(e);
  showError(String(e?.stack ?? e));
});
